import { APIClient } from "../api";

export default class SolutionTypeService extends APIClient {

    constructor(props: any) {
        super(props);
    }

    async getSolutionType() {
        const url = `${this.endpoint}/SolutionType`;

        return this.api({
            method: 'get',
            url
        });
    }
    async getClassificationById(id: number) {
        const url = `${this.endpoint}/SolutionType/${id}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getSolutionTypes(idBusinessArea: number) {
        const url = this.endpoint + `/SolutionType?$filter=(IdBusinessArea eq ${idBusinessArea} and Disabled eq 0)&$top=300`;

        return this.api({
            method: 'get',
            url
        });
    }

}